
function formatSourceName(source) {
  return source
    .split("_")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function ValidationCheckResult({ customers }) {

  const summary = customers.summary;
  const dataUnavailable = customers.dataUnavailable;

  const allowedCustomers = customers.results.filter(customer => customer.allowed);
  const deniedCustomers = customers.results.filter(customer => !customer.allowed);

  return (
    <div className="resultado-container">
      <h2>Resultado da Validação</h2>

      {dataUnavailable && (
        <div className="data-unavailable-banner">
          <span className="data-unavailable-icon">▸</span>
          <div className="data-unavailable-body">
            <p className="data-unavailable-message">{dataUnavailable.message}</p>
            <div className="data-unavailable-sources">
              {dataUnavailable.sources.map((source, index) => (
                <span className="data-unavailable-tag" key={index}>
                  {formatSourceName(source)}
                </span>
              ))}
            </div>
          </div>
        </div>
      )}

      <div
        className="summary"
        dangerouslySetInnerHTML={{ __html: summary }}
      />
      <div className="listas-container">
        {/* Clientes Permitidos */}
        <div className="lista clientes-permitidos">
          <h3>Clientes Permitidos</h3>
          {allowedCustomers.length === 0 ? (
            <p>Nenhum cliente permitido para este perfil.</p>
          ) : (
            <div className="logos-container">
              {allowedCustomers.map((customer, index) => (
                <div className="logo-item" key={index}>
                  <img
                    src={customer.logo}
                    alt={`Logo ${customer.company}`}
                    className="cliente-logo"
                  />
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Clientes Não Permitidos */}
        <div className="lista clientes-nao-permitidos">
          <h3>Clientes Não Permitidos</h3>
          {deniedCustomers.length === 0 ? (
            <p>Todos os clientes foram permitidos.</p>
          ) : (
            <div className="logos-container">
              {deniedCustomers.map((customer, index) => (
                <div className="logo-item" key={index}>
                  <img
                    src={customer.logo}
                    alt={`Logo ${customer.company}`}
                    className="cliente-logo cliente-logo-cinza"
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
